import { t } from "ttag";

import { isObject } from "metabase-types/guards";

import { FormMessageStyled } from "./FormMessage.styled";

export type Response = {
  status: number;
  data?: {
    message?: string;
  };
};

function isResponse(value: unknown): value is Response {
  return (
    isObject(value) &&
    "status" in value &&
    typeof value.status === "number" &&
    (value.data === undefined ||
      (isObject(value.data) && typeof value.data.message === "string"))
  );
}

interface FormMessageProps {
  className?: string;
  message?: string;
  noPadding?: boolean;
  formSuccess?: Response;
  formError?: unknown;
}

const getMessage = ({
  message,
  formError,
  formSuccess,
}: Pick<FormMessageProps, "message" | "formError" | "formSuccess">) => {
  if (message) {
    return message;
  }
  if (formError) {
    return getErrorMessage(formError);
  }
  return getSuccessMessage(formSuccess);
};

/**
 * @deprecated
 */
export const getErrorMessage = (formError?: unknown) => {
  if (isResponse(formError)) {
    if (formError.data?.message) {
      return formError.data.message;
    } else if (formError.status >= 400) {
      return t`Server error encountered`;
    }
  }
  if (formError) {
    return t`Unknown error encountered`;
  }
};

/**
 * @deprecated
 */
export const getSuccessMessage = (formSuccess?: Response) => {
  return formSuccess?.data?.message;
};

export function FormMessage({
  className,
  message,
  formSuccess,
  formError,
  noPadding,
}: FormMessageProps) {
  const treatedMessage = getMessage({ message, formSuccess, formError });
  return (
    <FormMessageStyled
      className={className}
      visible={!!message}
      noPadding={noPadding}
      hasSucceeded={!!formSuccess}
    >
      {treatedMessage}
    </FormMessageStyled>
  );
}
